import Vue from 'vue'
import vuetify from "./plugins/vuetify";
import axios from 'axios';
import {GET_CONFIGS, POST_CONFIG} from './routes';


const state = new Vue({
    data: () => ({
        saving: false,
        fetched: false,
        fetching: false,
        project_name: null,
        project_logo: null,
        project_background: null,
        id_label: null,
        driver_label: null,
        boolean_label: null,
        primary_color: null,
        secondary_color: null,
        recovered_container: null,
        scan_mod: null,
        manage_customer_verification: null,
        manage_vehicle_condition: null,
        manage_customer_signature: null,
        customer_photo_max: null,
        customer_photo_required: null,
        delivery_first_popup_visible: null,
        delivery_first_popup_title: null,
        delivery_first_popup_message: null,
        delivery_second_popup_visible: null,
        delivery_second_popup_title: null,
        delivery_second_popup_message: null,
    })
})

export default new Vue({
    computed: {
        saving() {
            return state.saving
        },
        fetching() {
            return state.fetching
        },
        project_name() {
            return state.project_name
        },
        project_background() {
            return state.project_background
        },
        project_logo() {
            return state.project_logo
        },
        id_label() {
            return state.id_label
        },
        driver_label() {
            return state.driver_label
        },
        boolean_label() {
            return state.boolean_label
        },
        boolean_title() {
            return state.delivery_first_popup_title
        },
        boolean_question() {
            return state.delivery_first_popup_message
        },
        primary_color() {
            return state.primary_color
        },
        secondary_color() {
            return state.secondary_color
        },
        recovered_container() {
            return state.recovered_container
        },
        scan_mod() {
            return state.scan_mod
        },
        manage_customer_verification() {
            return state.manage_customer_verification
        },
        manage_vehicle_condition() {
            return state.manage_vehicle_condition
        },
        manage_customer_signature() {
            return state.manage_customer_signature
        },
        customer_photo_max() {
            return state.customer_photo_max
        },
        customer_photo_required() {
            return state.customer_photo_required
        },
        delivery_first_popup_visible() {
            return state.delivery_first_popup_visible
        },
        delivery_first_popup_title() {
            return state.delivery_first_popup_title
        },
        delivery_first_popup_message() {
            return state.delivery_first_popup_message
        },
        delivery_second_popup_visible() {
            return state.delivery_second_popup_visible
        },
        delivery_second_popup_title() {
            return state.delivery_second_popup_title
        },
        delivery_second_popup_message() {
            return state.delivery_second_popup_message
        },
    },
    methods: {
        async save(payload = {}) {
            state.saving = true
            try {
                await axios.post(POST_CONFIG(), payload)
            } finally {
                state.saving = false
            }
        },
        async fetch(force = false) {
            if (!!state.fetched && !force) return
            state.fetching = true
            try {
                const response = await axios.get(GET_CONFIGS());
                const configs = response?.data?.data
                state.project_name = configs?.project_name
                state.project_logo = configs?.project_logo
                state.project_background= configs?.project_background
                state.id_label = configs?.id_label
                state.driver_label = configs?.driver_label
                state.boolean_label = configs?.boolean_label
                state.primary_color = configs?.primary_color
                state.secondary_color = configs?.secondary_color
                state.recovered_container = configs?.recovered_container
                state.scan_mod = configs?.scan_mod
                state.manage_customer_verification = configs?.manage_customer_verification
                state.manage_vehicle_condition = configs?.manage_vehicle_condition
                state.manage_customer_signature = configs?.manage_customer_signature
                state.customer_photo_max = configs?.customer_photo_max
                state.customer_photo_required = configs?.customer_photo_required
                state.delivery_first_popup_visible = configs?.delivery_first_popup_visible
                state.delivery_first_popup_title = configs?.delivery_first_popup_title
                state.delivery_first_popup_message = configs?.delivery_first_popup_message
                state.delivery_second_popup_visible = configs?.delivery_second_popup_visible
                state.delivery_second_popup_title = configs?.delivery_second_popup_title
                state.delivery_second_popup_message = configs?.delivery_second_popup_message

                const { light, dark } = vuetify.framework.theme.themes
                light.primary = dark.primary = state.primary_color
                light.secondary = dark.secondary = state.secondary_color
            } finally {
                state.fetching = false
            }
        },
    }
})
